import zip from 'lodash/zip';

/**
 * Template string tag to print strings with "double quotes"
 * Useful for message message where you want to identify empty strings
 *
 * prettyPrint`Hello ${'world'}` => 'hello "world"'
 * prettyPrint`Hello ${''}` => 'hello ""'
 * prettyPrint`Hello ${'123'}, ${null}, ${undefined}` => 'hello 123, null, undefined'
 */
const prettyPrint = (strings: TemplateStringsArray, ...inputs: any[]) => {
  const fragments = inputs.map((input) => (typeof input === 'string' ? `"${input}"` : `${input}`));

  return zip(strings, fragments).flat().join('');
};

export function getRegisterState(registerElement: HTMLElement): RegisterState {
  let target = registerElement;
  while (target.parentElement && target.getAttribute('data-automation') !== 'registerRootElement') {
    target = target.parentElement;
  }

  const registerID = target.getAttribute('data-register-id') ?? '';
  const registerName = target.getAttribute('data-register-name') ?? '';
  const status = target.getAttribute('data-register-status') as RegisterStatus;

  if (!registerID) {
    throw prettyPrint`Invalid registerID: ${registerID}`;
  }

  if (!status) {
    throw prettyPrint`Invalid register status: ${status}`;
  }

  return {
    registerID,
    registerName,
    status,
  };
}
